<template>
  <div class="genre has-background-white-bis fixspace">
    <section class="hero is-medium" style="background: #fff;">
    <!-- <section class="hero is-medium"> -->
      <div class="hero-body py-6">
        <div class="container">
          <div class="columns is-vcentered">
            <div class="column is-four-fifths">
              <!-- <p v-if="this.user.loggedIn && (this.user.data.uid === this.userId)"
                 class="is-size-5 is-size-6-mobile
                 has-text-weight-semibold has-text-centered-mobile">
                {{ $t('member.welcome') }}
              </p> -->
              <div class="columns mt-3 is-centered">
                <div class="column is-1 mr-3 is-hidden-mobile">
                  <figure class="has-background-grey-light image is-64x64 shadowed">
                    <img
                      :src="userData.photo_url || '/assets/noavatar.png'"
                      :alt="userData.name">
                  </figure>
                </div>
                <div class="column">
                  <figure
                    class="has-background-grey-light
                      image is-128x128 is-hidden-desktop is-hidden-tablet-only mb-5 shadowed"
                    style="margin:0 auto;"
                  >
                    <img
                      :src="userData.photo_url || '/assets/noavatar.png'"
                      :alt="userData.name"
                    />
                  </figure>
                  <div class="has-text-black is-size-3 is-size-4-mobile has-text-centered-mobile"
                    style="line-height: 1.2; font-weight:900">
                    {{ userData.name }}<span v-if="loadingVideo">{{'\xa0'}}</span>
                  </div>
                  <p class="pt-2 is-size-7 has-text-weight-medium has-text-centered-mobile">
                    @{{ userData.user_name || userData.id }}
                  </p>
                </div>
              </div>
            </div>
            <div class="column is-one-fifth">
              <div class="is-flex is-justify-content-center is-align-content-center">

                <button class="button mx-1 px-5 is-black" @click="shareModal">
                  <span class="has-text-weight-semibold">
                    {{ $t('general.share') }}
                  </span>
                </button>

<!--                <button v-if="this.user.loggedIn"-->
<!--                        class="button mx-1 px-5 is-dark is-outlined is-radiusless">-->
<!--                  <span class="has-text-weight-semibold">-->
<!--                    {{ $t('member.signout') }}-->
<!--                  </span>-->
<!--                </button>-->
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>

    <section class="section mb-5">
      <div class="container mb-5">
        <h1 v-if="this.user.loggedIn && (this.user.data.uid === this.userId)"
          class="title is-6 has-text-weight-bold mb-1">
          {{ $t('member.mylikes') }}
        </h1>
        <h1 v-else class="title is-6 has-text-weight-bold mb-1">
          {{ userData.name }} {{ $t('member.likes') }}
        </h1>
        <p class="is-size-7 has-text-grey-light has-text-weight-semibold">
          {{ total }} {{ $t('member.performance') }}
        </p>
      </div>

      <div class="container" v-if="loadingVideo">
        <div class="columns is-multiline">
          <div class="column is-one-third" v-for="i in generalske" :key="i">
            <div class="media-content">
              <figure class="image is-16by9 skeleton">
                <div class="skeleton-block"></div>
              </figure>
              <div class="pt-1"><b-skeleton></b-skeleton></div>
              <b-skeleton width="30%"></b-skeleton>
            </div>
          </div>
        </div>
      </div>

      <div class="container" v-if="!loadingVideo && total > 0">
        <div class="columns is-multiline">
          <div class="column is-one-third-desktop is-half-tablet"
            v-for="(item, index) in list" :key="item.id">
            <div style="position: absolute; z-index:5; background-color: rgba(200,200,200,0.0);">
              <p class="buttons ml-2 mt-2">
                <button class="button is-small is-white"
                        v-on:click="playVideoAndSetQueue(index)" @click="() => playerCard(false)"
                >
                  <span class="icon is-small">
                    <i class="fas fa-play has-text-grey-dark"></i>
                  </span>
                </button>
                <button class="button is-small is-white"
                        v-if="user.loggedIn"
                        v-on:click="removeVideoFromFavorite(item.id)"
                >
                  <span class="icon is-small">
                    <i class="fas fa-times fa-lg has-text-grey-dark"></i>
                  </span>
                </button>
              </p>
            </div>
            <router-link :to='"/video/" + item.id' :title="item.title">
              <video-item
                :channel-title="item.channel.title"
                :youtube-id="item.provider_video_id"
                :title="item.title" >
              </video-item>
            </router-link>
          </div>
        </div>
      </div>

      <div class="container has-text-centered" v-if="!loadingVideo && total === 0">
        <h1 class="has-text-black is-size-3-desktop is-size-5-mobile"
            style="font-weight:600;">
          {{ $t('member.nolikes') }}
        </h1>
        <p class="has-text-grey is-size-6-desktop is-size-6-mobile pt-3 pb-6">
          {{ $t('member.nolikesmsg') }}
        </p>
        <router-link to="/explore">
          <button class="button mx-1 px-5 is-black">
            <span class="has-text-weight-semibold">
              {{ $t('member.nolikescta') }}
            </span>
          </button>
        </router-link>
      </div>

      <div class="container has-text-centered">
        <infinite-loading
          v-if="isFirstPageFinished"
          spinner="waveDots"
          @infinite="infiniteHandler">
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
      </div>
    </section>
  </div>
</template>

<script>
import ShareModal from 'components/ShareModal.vue';
import { getFavoriteVideos, removeFavoriteVideo, getUserInfo } from '@/api/api';
import { mapGetters } from 'vuex';
import store from '@/store';

export default {
  name: 'Home',

  metaInfo() {
    return {
      title: this.$t('title.userlikes'),
      meta: [
        { property: 'og:title', vmid: 'og:title', content: this.$t('title.userlikes') },
      ],
    };
  },

  data() {
    return {
      userId: null,
      userData: {
        id: null,
        name: null,
        user_name: null,
        photo_url: null,
      },
      total: 0,
      page: 1,
      lastPage: 1,

      loadingVideo: false,
      list: [],
      hometopske: 3,
      generalske: 12,

      isFirstPageFinished: false,
    };
  },

  computed: {
    ...mapGetters({
      user: 'user',
    }),
  },

  created() {
    this.userId = this.$route.params.id;
    this.fetchData();
  },

  mounted() {
    this.forGtag();
  },

  beforeDestroy() {
    clearTimeout(this.timer);
  },

  methods: {
    shareModal() {
      this.$FModal.show({
        component: ShareModal,
        overlayStyles: {
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
        },
      },
      {
        shareId: this.userId,
        shareRoute: 'user',
        shareTitle: this.userData.name,
      });
    },

    playerCard(show) {
      this.$parent.setStatePlayerCard(show);
    },

    fetchData() {
      this.loadingVideo = true;

      getUserInfo(this.userId)
        .then((result) => {
          this.userData = result.data;
        })
        .catch((err) => {
          console.error(err);

          if (err.request.status === 404) {
            this.$router.push({ name: '404' });
          }
        });

      getFavoriteVideos({ params: { user_id: this.userId, page: this.page } })
        .then((result) => {
          const {
            data,
            total,
            current_page: page,
            last_page: lastPage,
          } = result.data;

          this.list = data;
          this.total = total;
          this.lastPage = lastPage;
          this.page = page;
          this.loadingVideo = false;

          this.isFirstPageFinished = true;
        })
        .catch((err) => { console.error(err); });
    },

    removeVideoFromFavorite(videoId) {
      if (this.user.loggedIn) {
        removeFavoriteVideo(videoId)
          .then(() => {
            const index = this.list.findIndex((video) => video.id === videoId);
            this.list.splice(index, 1);
            this.total += -1;
          })
          .catch((err) => { console.error(err); });

        this.$gtag.event('favorite_remove', {
          event_category: 'user_related',
          event_label: 'User removed favorite video',
          value: 1,
        });
      }
    },

    infiniteHandler($state) {
      if (this.page + 1 > this.lastPage) {
        $state.complete();
        return;
      }

      this.page += 1;

      getFavoriteVideos({ params: { user_id: this.userId, page: this.page } })
        .then((result) => {
          const { data } = result.data;

          if (data.length > 0) {
            this.list.push(...data);
            store.dispatch('setPlayerQueue', { list: this.list });

            $state.loaded();
          } else {
            $state.complete();
          }
        }).catch((err) => { console.error(err); });
    },

    async playVideoAndSetQueue(index) {
      await store.dispatch('setPlayerQueue', { list: this.list });
      await store.dispatch('setPlayerCurrentPlay', { index });

      this.$gtag.event('favorite_play', {
        event_category: 'user_related',
        event_label: 'User play favorite video',
        value: 1,
      });
    },

    forGtag() {
      this.timers = setTimeout(() => {
        this.$emit('forGtagStatus', this.$t('title.userlikes'));
      }, 500);
    },
  },
};
</script>
